<template>
    <div class="dropdown mb-3">
        <a href="#" class="h6 mb-0" role="button" id="dealer-filter-dropdown-button" data-toggle="dropdown" aria-expanded="false">
          <i class="fa fa-filter"></i>
        </a>
        <div ref="dropdown" class="dropdown-menu card-filter-dropdown-menu" aria-labelledby="dealer-filter-dropdown-button">
            <div class="card border-0">
                <div class="card-header bg-transparent border-0">
                    Filter
                </div>
                <form method="get" @submit="submit" :action="action">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="form-group">
                                <label for="programs">Programs</label>
                                  <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="program-isa" value="isa" v-model="form.programs" name="programs[]"/>
                                    <label class="form-check-label" for="program-isa">
                                      ISA
                                    </label>
                                  </div>
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" id="program-dia" value="dia" v-model="form.programs" name="programs[]"/>
                                      <label class="form-check-label" for="program-dia">
                                          DIA
                                      </label>
                                  </div>
                            </div>
                        </div>
                        <div class="form-group">
                          <label class="d-block">Enrolled</label>
                          <div class="form-check form-check-inline">
                            <input type="radio" id="yes-enrolled" value="true" v-model="form.enrolled" name="enrolled"/>
                            <label class="form-check-label" for="yes-enrolled">
                              Yes
                            </label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input type="radio" id="no-enrolled" value="false" v-model="form.enrolled" name="enrolled"/>
                            <label class="form-check-label" for="no-enrolled">
                              No
                            </label>
                          </div>
                        </div>
                        <div class="form-group">
                            <label class="d-block">Enrolled In Challenges</label>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="yes-enrolled_in_challenges" value="true" v-model="form.enrolled_in_challenges" name="enrolled_in_challenges"/>
                                <label class="form-check-label" for="yes-enrolled_in_challenges">
                                    Yes
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="no-enrolled_in_challenges" value="false" v-model="form.enrolled_in_challenges" name="enrolled_in_challenges"/>
                                <label class="form-check-label" for="no-enrolled_in_challenges">
                                    No
                                </label>
                            </div>
                        </div>
                        <div class="form-group mb-0 mt-3">
                            <label for="dealer-id">Dealer Id</label>
                            <input type="text" id="dealer-id" v-model="form.dealer_id" name="dealer_id"/>
                        </div>
                    </div>
                    <div class="card-footer border-0 bg-transparent d-flex justify-content-between align-items-center">
                        <a v-if="!pending" @click="submit" :href="action">Clear Filters</a>
                        <div v-else></div>
                        <button class="btn btn-secondary" type="submit">Apply Filters</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

const DEFAULT = {
    programs: [],
    enrolled: true,
    enrolled_in_challenges: null,
    dealer_id: null
}

export default {
    props: {
        params: {
            type: Object,
            default() {
                return {};
            }
        },
        action: {
            type: String
        }
    },
    data() {
        return {
            form: {...DEFAULT, ...this.params},
            pending: false
        }
    },
    methods: {
        submit() {
            this.pending = true;
        }
    }
}
</script>
